import { useState } from 'react';
import '../../styles/ModalImpresion.css';

// Obtener URL base del API
const getApiBaseUrl = () => {
  const baseHost = (process.env.REACT_APP_API_URL || 'window.location.origin/api').replace('/api', '');
  return baseHost;
};

const ModalOpcionesImpresion = ({
  isOpen,
  onClose,
  opciones,
  whatsappData,
  titulo = "Opciones de Impresión",
  onOpcionSeleccionada
}) => {
  const [procesando, setProcesando] = useState(null);

  if (!isOpen) return null;

  const tenantInfo = localStorage.getItem('tenant_info') ? JSON.parse(localStorage.getItem('tenant_info')) : null;
  const tenantSlug = tenantInfo?.slug || tenantInfo?.codigo || localStorage.getItem('tenant_codigo');

  const manejarOpcion = async (opcion) => {
    setProcesando(opcion.id);
    try {
      const API_BASE_URL = getApiBaseUrl();
      console.log('=== DEBUG MODAL IMPRESIÓN ===');
      console.log('Opción seleccionada:', opcion);
      console.log('API_BASE_URL:', API_BASE_URL);
      console.log('Endpoint completo:', `${API_BASE_URL}${opcion.endpoint}`);
      console.log('Tipo de archivo:', opcion.tipo_archivo);

      if (opcion.tipo_archivo === 'html') {
        // Abrir en nueva ventana para imprimir
        const url = `${API_BASE_URL}${opcion.endpoint}`;
        console.log('Abriendo URL para imprimir:', url);

        // Agregar token como parámetro de query para autenticación
        const token = localStorage.getItem('token');
        const params = new URLSearchParams();
        if (token) params.append('token', token);
        if (tenantSlug) params.append('tenant', tenantSlug);
        const urlConToken = `${url}${url.includes('?') ? '&' : '?'}${params.toString()}`;
        window.open(urlConToken, '_blank');
      } else if (opcion.tipo_archivo === 'pdf') {
        // Descargar PDF
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}${opcion.endpoint}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${opcion.id}_${Date.now()}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          throw new Error('Error al generar el PDF');
        }
      } else if (opcion.tipo_archivo === 'whatsapp') {
        // Obtener datos de WhatsApp y abrir
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}${opcion.endpoint}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.url) {
            window.open(data.url, '_blank');
          } else {
            throw new Error('No se pudo generar el enlace de WhatsApp');
          }
        } else {
          throw new Error('Error al preparar el mensaje de WhatsApp');
        }
      } else if (opcion.tipo_archivo === 'combinar') {
        // Ejecutar imprimir Y WhatsApp
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}${opcion.endpoint}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();

          // Abrir imprimir
          if (data.html_url) {
            const params = new URLSearchParams();
            if (token) params.append('token', token);
            if (tenantSlug) params.append('tenant', tenantSlug);
            const urlConToken = `${API_BASE_URL}${data.html_url}${data.html_url.includes('?') ? '&' : '?'}${params.toString()}`;
            window.open(urlConToken, '_blank');
          }

          // Abrir WhatsApp
          if (data.whatsapp_data && data.whatsapp_data.url) {
            setTimeout(() => {
              window.open(data.whatsapp_data.url, '_blank');
            }, 1000);
          }
        } else {
          throw new Error('Error al ejecutar la acción combinada');
        }
      }

      if (onOpcionSeleccionada) {
        onOpcionSeleccionada(opcion);
      }
    } catch (error) {
      console.error('Error completo al ejecutar opción:', error);
      console.error('Detalles del error:', error.message);
      alert(`Error al ejecutar la acción seleccionada: ${error.message}`);
    } finally {
      setProcesando(null);
    }
  };

  return (
    <div className="modal-overlay-impresion">
      <div className="modal-content-impresion">
        <div className="modal-header-impresion">
          <h2>{titulo}</h2>
          <button className="btn-cerrar-impresion" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body-impresion">
          <p className="mensaje-descripcion">
            Selecciona una opción para generar tu comprobante:
          </p>

          <div className="opciones-grid">
            {opciones?.map((opcion) => (
              <button
                key={opcion.id}
                className={`opcion-btn ${procesando === opcion.id ? 'procesando' : ''}`}
                onClick={() => manejarOpcion(opcion)}
                disabled={procesando !== null}
              >
                <div className="opcion-icono">
                  {procesando === opcion.id ? '⏳' : opcion.icono}
                </div>
                <div className="opcion-info">
                  <div className="opcion-nombre">{opcion.nombre}</div>
                  <div className="opcion-descripcion">{opcion.descripcion}</div>
                </div>
              </button>
            ))}
          </div>

          {whatsappData && (
            <div className="whatsapp-preview">
              <h4>📱 Vista previa del mensaje:</h4>
              <div className="mensaje-preview">
                {whatsappData.mensaje}
              </div>
              <p className="telefono-info">
                📞 Se enviará a: {whatsappData.telefono}
              </p>
            </div>
          )}

          <div className="modal-footer-impresion">
            <button className="btn-cancelar-impresion" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalOpcionesImpresion;